import { defineSlotRecipe } from '@chakra-ui/react';
import { progressAnatomy } from '@chakra-ui/react/anatomy';

// NOTE: This is the global ProgressCircle recipe shared by every ProgressCircle
// in the app. The user-journey sidebar quote circle is styled separately via
// the `sidebar` slot recipe (progressCircle/progressRange/progressTrack slots)
// to keep its per-tenant look scoped. Consider consolidating here if more
// surfaces need tenant-specific progress styling.
export default defineSlotRecipe({
  slots: progressAnatomy.keys(),
  variants: {
    size: {
      xl: {
        circle: {
          '--size': '78px',
        },
        valueText: {
          fontSize: 'lg',
        },
      },
    },
  },
});
